import { render } from "./Wakey.vue?vue&type=template&id=b8f0117c"
import script from "./Wakey.vue?vue&type=script&lang=js"
export * from "./Wakey.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__